import { Alert } from '@bb/elements-web';
import React from 'react';
import styled from 'styled-components';
import { featureEnabled } from 'utils';

const PreBookingInfoAlert = ({ state }) => {
  const { appointmentConfig, externalConfig, listing } = state || {};
  if (!featureEnabled('preBookingNotificationFeature')) return null;
  if (!listing?.org.features.includes('PRE_BOOKING')) return null;
  const preBookingInformation = (appointmentConfig || externalConfig)
    ?.preBookingInformation;
  if (!preBookingInformation) return null;

  return (
    <StyledAlert
      data-cy="preBookingInfo-alert"
      type="info"
      message={preBookingInformation}
      showIcon
      closable
    />
  );
};

const StyledAlert = styled(Alert)`
  && {
    padding: 6px 10px;
    margin: 0 16px 8px;
  }
`;

export default PreBookingInfoAlert;
